import * as React from 'react';
import _ from 'lodash'
import { Resource } from '../../../../types';
import { submitResource, setResourceInProgress } from '../../../../api/resource';
// import TagPill from '../../../TagPill';
declare const I18n;

type Props = {
  resource: Resource,
  isAdmin: boolean,
  resourceCategoryId: number | string,
  index: number,
  handleDelete(id: number): void,
  showCategory?: boolean,
  isFacilitator?: boolean,
  isLearner?: boolean,
  cardBackground?: "primary" | "secondary",
  length_estimate?: string,
  duration?: string,
  resource_type?: string,
}

const ResourceListItem: React.FunctionComponent<Props> = ({
  resource,
  resourceCategoryId,
  index,
  handleDelete,
  isFacilitator,
  isLearner,
  isAdmin,
  showCategory = false,
  cardBackground = "primary"
}: Props): JSX.Element => {
  const [completed, setCompleted] = React.useState(resource.completed || false);
  let overlay = null;

  const viewLabelByResourceType: Record<string, string> = {
    pdf: "models.resource.messaging.view_pdf",
    link: "models.resource.messaging.view_link",
    post: "models.resource.messaging.view_post",
  };

  const handleCompleteResource = async () => {
    try {
      await submitResource(resource.id, {
        learner_id: (window as any).CURRENT_LEARNER_ID,
      });
      setCompleted(!completed)
    } catch (error) {
    }
  };

  const handleSetResourceInProgress = async () => {
    try {
      await setResourceInProgress(resource.id, {
        learner_id: (window as any).CURRENT_LEARNER_ID,
      });
    } catch (error) {
    }
  };
  const mod = index % 3;


  if (isLearner && completed) {
    overlay = "card-list-item__image--completed";
  }

  const imageNode = (
    <div className={`card-list-item__image-container ${overlay || ""}`}>
      {
        resource.cover_image_url ? (
          <div className="card-list-item__image card-list-item__image--background" style={{ backgroundImage: `url(${resource.cover_image_url})` }} />
        ) : (
          <div className="empty-card-container">
            <i className="fa fa-question-circle" style={{
              fontSize: '48px',
              border: 'none',
              outline: 'none',
              textDecoration: 'none'
            }}></i>
          </div>
        )
      }

      {completed && (
        <div className="card-list-item__overlay">
          <i
            className={`fal ${overlay.includes("completed") ? "fa-check-circle" : "fa-lock"
              } card-list-item__overlay-icon`}
            style={{
              color: overlay.includes("completed") ? "#8DC862" : "#A41461",
            }}
          />
        </div>
      )}

    </div>
  );

  return (
    <div
      className={`card-list-item ${cardBackground}`}
      style={{
        marginRight: (mod === 0 || mod === 1) ? '1.2%' : 0,
        marginLeft: (mod === 1 || mod === 2) ? '1.2%' : 0
      }}
    >
      <a
        id={`resource_id_${resource.id}`}
        style={{ cursor: 'pointer', textDecoration: 'none', borderRadius: '20px' }}
        href={resource.resource_url}
        target={resource.resource_type == 'post' ? '_self' : '_blank'}
      >
        {imageNode}
      </a>

      <div className="card-list-item__meta-container">
        <div>
          <div className="subinformation">
            {(resource as any).resource_category_name && (
              <div className="category-list">
                {(resource as any).resource_category_name}
              </div>
            )}
            {(resource.length_estimate !== 'null' && resource.length_estimate !== null && resource.length_estimate != '') &&
              <div className="flex-row">
                <div className="duration">
                  <i className="far fa-clock icon"></i>
                  {resource.length_estimate}
                </div>
              </div>
            }
          </div>

          <div className="card-list-item__title-container">
            <div id={`resource_title_${resource.id}`} className="card-list-item__title" style={{ color: '#fff' }}>
              {resource.title}
            </div>
            {
              isAdmin && (
                <div className="card-list-item__admin-container">
                  <a href={`/admin/explore_categories/${resourceCategoryId}/resources/${resource.id}/edit`}><i className="fal fa-edit card-list-item_icon--admin" /></a>
                  <div id={`delete_${resource.id}`} onClick={() => handleDelete(resource.id)}><i className="fal fa-trash card-list-item__icon--admin" /></div>
                </div>
              )
            }
          </div>
          <div className="card-list-item__desc-container">
            {
              resource.tags && (
                <div className="card-list-item__tag-container">
                  {
                    resource.tags.map((tag, index) => {
                      return (
                        <div className="card-list-item__tag--item">
                          {tag.name}
                          {index < resource.tags.length - 1 ? "," : ""}
                        </div>
                      )
                    })
                  }
                </div>
              )
            }
          </div>
        </div>

        <div className="card-list-item__button-container">
          <a
            href={resource.resource_url}
            target={resource.resource_type == 'post' ? '_self' : '_blank'}
            onClick={handleSetResourceInProgress}
            className={'btn btn-sm btn-primary btn-resource'}
          >
            {I18n.t(viewLabelByResourceType[resource.resource_type] ?? "models.resource.messaging.view_link")}
          </a>
          {isLearner && (
            <button
              type="button"
              className={`btn pull-right text-white btn-text no-underline font-weight-normal`}
              onClick={handleCompleteResource}
              style={{
                alignSelf: 'flex-start',
              }}
            >
              {completed ? (
                <>
                  <i className="fa-solid fa-square-check" style={{ marginRight: '0.5rem' }}></i>
                  {I18n.t("models.resource.messaging.completed")}
                </>
              ) : (
                <>
                  <i className="fa-regular fa-square" style={{ marginRight: '0.5rem'}}></i> {I18n.t("models.resource.messaging.mark_as_completed")}
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResourceListItem;